export interface OwnershipType {
  slug: string;
  label: string;
}

export const OWNERSHIP_TYPES: readonly OwnershipType[] = [
  { slug: "sole_ownership", label: "Sole ownership" },
  { slug: "jtwros", label: "Joint Tenancy with Right of Survivorship (JTWROS)" },
  { slug: "tbe", label: "Tenancy by the Entirety (TBE)" },
  { slug: "tic", label: "Tenants in Common (TIC)" },
  { slug: "community_property", label: "Community Property" },
  {
    slug: "community_property_survivorship",
    label: "Community Property with Right of Survivorship",
  },
  { slug: "revocable_trust", label: "Held in Revocable (Living) Trust" },
  { slug: "irrevocable_trust", label: "Held in Irrevocable Trust" },
  { slug: "pod_tod", label: "POD / TOD Beneficiary Designated" },
  { slug: "beneficiary_designation", label: "Beneficiary Designation (contract)" },
  { slug: "custodial_decedent", label: "Custodial (UTMA / UGMA)" },
  { slug: "beneficial_interest", label: "Beneficial interest in another person's trust" },
  { slug: "specific_bequest", label: "Specific bequest in will" },
] as const;

export function getOwnershipLabel(slug: string | null | undefined): string | null {
  if (!slug) return null;
  return OWNERSHIP_TYPES.find((t) => t.slug === slug)?.label ?? slug;
}
